import AiFactory from './Controllers/AiFactory.controller';
export default AiFactory;
